import React, { FC, useState } from "react";
import { Input, Button, Modal, Row, Col } from "antd";
import _ from "lodash";
import EventCalendarPreview from "../../common/EventCalendarPreview";

const CalendarModal: FC<{ onClose: () => void; socket?: ISocket }> = (
  props
) => {
  const { onClose, socket } = props;
  const [isModalVisible, setIsModalVisible] = useState(true);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const handleOk = () => {};

  return (
    <Modal
      title="&nbsp;"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1000px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <EventCalendarPreview />
    </Modal>
  );
};

export default CalendarModal;
